import request from 'utils/request';
import config from 'config/Config';

export default class {
  /**
   * 注册时若手机号已绑定会员卡则需根据绑定的会员卡号状态来增加弹窗提示
   */
  static getMemberInfoByPhone(params) {
    return request({
      url: `user/info/getMemberInfoByPhone`,
      host: config.HOST_MALL,
      ignoreErr: true,
      params
    });
  }

  /**
   * 获取图形二维码
   */
  static getCaptcha(phone) {
    return request({
      url: `user/verifyCode/captcha?phone=${phone}`,
      host: config.HOST_MALL,
      returnAll: true
    });
  }

  /**
   * 校验图形二维码
   */
  static getImageCode(params) {
    return request({
      url: `user/verifyCode/checkCaptcha`,
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }

  /**
   * 获取验证码
   */
  static getVerifyCode(params) {
    return request({
      url: `user/verifyCode/getVerifyCodeV3`,
      host: config.HOST_MALL,
      ignoreErr: true,
      params
    });
  }

  /**
   * 注册
   */
  static register(params) {
    return request({
      url: 'user/register/register',
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }

  /**
   * 注册
   */
  static registerGoogle(params) {
    return request({
      url: 'user/register/google',
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }

  /**
   * 虚拟点位的注册
   * @param {*} params
   * @returns
   */

  static registerVirtual(params) {
    return request({
      url: 'user/register/confirmOrRegister',
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }

  /**
   * 根据code获取微信openId、accessToken等信息
   */
  static getWxMsgByToken(params) {
    return request({
      url: 'user/login/getWechatUserInfo',
      host: config.HOST_MALL,
      params
    });
  }

  /**
   * 校验实体卡密是否正确
   */
  static applyPhysicalCard(params) {
    return request({
      url: 'user/register/checkEntityCard',
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }

  /**
   * 查询是否可开实体卡或虚拟卡
   */
  static queryCanApplyType(params) {
    return request({
      url: 'user/register/checkOpenCardAttribute',
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }

  /**
   * 获取协议(registration: 注册须知，agency: 经销商合同)
   */
  static getAgreement(type) {
    return request({
      url: `basic/contract/query/${type}`,
      host: config.HOST_MALL
    });
  }

  static getCardCodeInfo(params) {
    return request({
      url: `personal/querySystemByCardCode`,
      host: config.HOST_MALL,
      params
    });
  }

  static getCardCodeInfoNew(params) {
    return request({
      url: `personal/queryRegisterCardCode`,
      host: config.HOST_MALL,
      params
    });
  }

  // 申请开卡
  static apply(params) {
    return request({
      url: `user/register/queryCardType`,
      host: config.HOST_MALL,
      method: 'post_json',
      data: params,
      ignoreErr: true
    });
  }

  static getCardCodeName(params) {
    return request({
      url: `personal/queryMemberNameByCardCode?cardCode=${params}`,
      host: config.HOST_MALL,
      ignoreErr: true
    });
  }

  // 可儿玫瑰更新健康顾问
  static setKerUpdateHealth(params) {
    return request({
      url: `user/info/updateHealth?healthCode=${params}`,
      host: config.HOST_MALL,
      method: 'post_json',
      ignoreErr: true
    });
  }
  // 升级 - 查询卡类型
  static queryCardType(params) {
    return request({
      url: 'user/upgrade/queryCardType',
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }
  // linkflow识别联系人
  static linkflowIdentifiers(params) {
    return request({
      url: 'linkflow/identifiers',
      host: config.HOST_MALL,
      method: 'post_json',
      ignoreErr: true,
      data: params
    });
  }
  // 获取民族列表
  static getNationList(params) {
    return request({
      url: `basic/nation/list`,
      host: config.HOST_MALL,
      params
    });
  }
  // 手机号获取健康顾问卡号
  static queryHealthCardCodeByPhone(params) {
    console.log('params>>>', params);
    return request({
      url: `user/register/queryHealthCardCodeByPhone`,
      host: config.HOST_MALL,
      params
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/Register/RegisterServ.js